module.exports = __webpack_public_path__ + "img/flegship.51fe5b46.jpg";